import _DatabaseModel, { i18n } from "./_DatabaseModel";
import { toSnakeCase } from "../mixins/HelperFunctions";

const DATA_SETS_TAB_DEFINITION = 49;

class DataSet extends _DatabaseModel {
  static model = "data_set";
  static editDialogComponent = "data-sets-edit-dialog";
  static createNewObject = { object: { definition: {} } };

  static tableHeaders = [
    { textKey: "form.label.name", value: "name" },
    { textKey: "data_set.label.target_entity", value: "target_entity" },
  ];

  static show = {
    buttons: ["edit", "open"],
    reloadingModels: [],
  };

  static filter = {
    parts: {
      fields: ["name", "target_entity"],
      extended_fields: ["description", "time_filter"],
      time_filter: ["created_at", "updated_at"],
    },
  };

  static target_entities = [
    "Activity",
    "AppliedSla",
    "Asset",
    "AssetCategory",
    "AssetsIssue",
    "AutomatedAction",
    "Contract",
    "DataSet",
    "Document",
    "ExternalEmail",
    "Field",
    "Issue",
    "Kpi",
    "Person",
    "PersonCategory",
    "PriceItem",
    "PriceItemsWarehouse",
    "PriceList",
    "Report",
    "Requirement",
    "Risk",
    "Role",
    "Service",
    "Snippet",
    "Subscription",
    "Task",
    "Threat",
    "Translation",
    "User",
    "Vulnerability",
    "Warehouse",
    "WarehouseTransactionItem",
  ];

  static cardFields(object) {
    return {
      title: object.name,
      subtitle: i18n.t(
        `${toSnakeCase(object.target_entity)}.${toSnakeCase(
          object.target_entity
        )}`
      ),
    };
  }

  static basicInfo(object) {
    return [
      {
        labelKey: "data_set.label.target_entity",
        value: i18n.t(
          `${toSnakeCase(object.target_entity)}.${toSnakeCase(
            object.target_entity
          )}`
        ),
        type: "plain",
      },
      {
        labelKey: "form.label.created_at",
        value: object.created_at,
        type: "date_time",
      },
    ];
  }

  static submenuActions = [
    this.commonActions.duplicate,
    this.commonActions.openActivities,
    this.commonActions.delete,
  ];

  static tabs = [
    this.detailTab,
    {
      titleKey: "data_set.label.definition",
      permission: DATA_SETS_TAB_DEFINITION,
      component: "JsonDefinitionTab",
      disabled: () => false,
    },
  ];
}

export default DataSet;
